import { memo, useMemo } from "react";

import StatusCellWrapper from "./StatusCellWrapper";
import { isLightColor } from "../../../lib/script";

function StatusCellInnerV2({ children, itemKey, caseData, text, classes, classesCell, noDataCell }) {
    const { textColor, bkColor, cellClassName } = useMemo(() => {
        let color = null;
        let nextTextColor = null;
        let nextBkColor = null;

        if (text && text.color) {
            color = text.color.split(" ").join("_");
        }

        if (text && text.color_code) {
            nextBkColor = text.color_code;
            const lightDark = isLightColor(text.color_code);
            nextTextColor = lightDark ? "var(--text)" : "var(--white)";
        } else {
            nextTextColor = null;
            nextBkColor = null;
        }

        const cellClass = `${classes.status_cell} ${classesCell.body_cell} ${color ? "bk_" + color : ""} ${
            noDataCell ? classesCell.no_data_cell : ""
        }`;

        return { textColor: nextTextColor, bkColor: nextBkColor, cellClassName: cellClass };
    }, [text, classes.status_cell, classesCell.body_cell, classesCell.no_data_cell, noDataCell]);

    return (
        <StatusCellWrapper itemKey={itemKey} caseData={caseData}>
            <div style={{ backgroundColor: bkColor, color: textColor }} className={cellClassName}>
                {children}
            </div>
        </StatusCellWrapper>
    );
}

export default memo(StatusCellInnerV2);